import React from 'react'
import { FormattedMessage } from 'react-intl'

const firstLastNameIntl = { id: 'TeamProfile.firstLastName', defaultMessage: 'First & Last Name' };
const companyEmailIntl = { id: 'TeamProfile.companyEmail', defaultMessage: 'Company Email' };
const phoneIntl = { id: 'TeamProfile.phone', defaultMessage: 'Phone' };
const jobTitleIntl = { id: 'TeamProfile.jobTitle', defaultMessage: 'Job Title' };
const enterEmployeeIDIntl = { id: 'TeamProfile.enterEmployeeID', defaultMessage: 'Enter Employee ID' };
const selectAccessLevelIntl = { id: 'TeamProfile.selectAccessLevel', defaultMessage: 'Select Access Level' };
const unregisteredIntl = { id: 'TeamProfile.unregistered', defaultMessage: 'Unregistered' };
const pendingIntl = { id: 'TeamProfile.pending', defaultMessage: 'Pending' };
const activeIntl = { id: 'TeamProfile.active', defaultMessage: 'Active' };
const adminIntl = { id: 'TeamProfile.admin', defaultMessage: 'Admin' };
const teamMemberIntl = { id: 'TeamProfile.teamMember', defaultMessage: 'Team Member' };
const emptyIntl = { id: 'TeamProfile.empty', defaultMessage: ' ' };

const addTeamMember = (<FormattedMessage id="AddUnregisteredUserComponent.addMemberTitle" defaultMessage="Add Team Member" />);
const confirm = (<FormattedMessage id="Generic.confirm" defaultMessage="Confirm" />);
const cancel = (<FormattedMessage id="Generic.cancel" defaultMessage="Cancel" />);
const phone = (<FormattedMessage id="Generic.phone" defaultMessage="Phone" />);
const accessLevel = (<FormattedMessage id="Generic.accessLevel" defaultMessage="Access Level" />);
const status = (<FormattedMessage id="Generic.status" defaultMessage="Status" />);
const edit = (<FormattedMessage id="Generic.edit" defaultMessage="Edit" />);
const save = (<FormattedMessage id="Generic.save" defaultMessage="Save" />);
const addNewGroup = (<FormattedMessage id="Generic.addNewGroup" defaultMessage="+ Add New Group" />);
const admin = (<FormattedMessage id="Generic.admin" defaultMessage="Admin" />);
const teamMember = (<FormattedMessage id="Generic.teamMember" defaultMessage="Team Member" />);
const remove = (<FormattedMessage id="Generic.remove" defaultMessage="Remove" />);
const removeUser = (<FormattedMessage id="TeamProfile.removeUser" defaultMessage="Remove User" />);
const inviteUser = (<FormattedMessage id="TeamProfile.inviteUser" defaultMessage="Invite User" />);
const employeeProfile = (<FormattedMessage id="TeamProfile.employeeProfile" defaultMessage="Employee Profile" />);
const employeeInformation = (<FormattedMessage id="TeamProfile.employeeInformation" defaultMessage="Employee Information" />);
const profilePhoto = (<FormattedMessage id="TeamProfile.profilePhoto" defaultMessage="Profile Photo" />);
const fullName = (<FormattedMessage id="TeamProfile.fullName" defaultMessage="Full Name" />);
const notVerified = (<FormattedMessage id="TeamProfile.notVerified" defaultMessage="Not Verified" />);

const email = (<FormattedMessage id="Header.email" defaultMessage="Email" />);
const jobTitle = (<FormattedMessage id="Header.jobTitle" defaultMessage="Job Title" />);
const employeeID = (<FormattedMessage id="Header.employeeID" defaultMessage="Employee ID" />);
const department = (<FormattedMessage id="Header.department" defaultMessage="Department" />);
const skill= (<FormattedMessage id="Header.skill" defaultMessage="Skill" />);
const group = (<FormattedMessage id="Header.group" defaultMessage="Group" />);
const skills = (<FormattedMessage id="Header.skills" defaultMessage="Skills" />);

const contactInfo = (<FormattedMessage id="Header.contactInfo" defaultMessage="Contact Info" />);
const departments = (<FormattedMessage id="Header.departments" defaultMessage="Departments" />);

const rolesAndSkills = (<FormattedMessage id="Header.roleAndSkills" defaultMessage="Roles" />);

const removeSkill = (skillName) => (<FormattedMessage id="TeamProfile.removeSkill" defaultMessage="Remove {name} Skill?" values={{ name: skillName}} />);
const removeSkillExplain = (skillName) => (<FormattedMessage id="TeamProfile.removeSkillExplain" defaultMessage="Confirm you would like to delete the {name} skill. All Members will be removed from this skill." values={{ name: skillName }} />);

const removeRole = (roleName) => (<FormattedMessage id="TeamProfile.removeRole" defaultMessage="Remove {name} Role?" values={{ name: roleName}} />);
const removeRoleExplain = (roleName) => (<FormattedMessage id="TeamProfile.removeRoleExplain" defaultMessage="Confirm you would like to delete the {name} role. All Members will be removed from this role." values={{ name: roleName}} />);

const groupExplain = (<FormattedMessage id="TeamProfile.groupExplain" defaultMessage="Groups are custom collections of users for broadcasting shifts in the Shift Marketplace. When you create a Group, you can easily broadcast shifts to Group members." />);
const removePhotoExplain = (<FormattedMessage id="TeamProfile.removePhotoExplain" defaultMessage="Confirm you would like to remove this user's profile photo." />);
const removePhotoTitle = (<FormattedMessage id="TeamProfile.removePhotoTitle" defaultMessage="Remove User Profile Photo." />);

const removeUserExplain = (<FormattedMessage id="TeamProfile.removeUserExplain" defaultMessage="This will terminate the user and remove them from your location. This action cannot be undone. Type {bolded} to confirm." values={{ bolded: <b>REMOVE</b> }} />);
const removeUserTitle = (fullName) => (<FormattedMessage id="TeamProfile.removeUserTitle" defaultMessage="Remove {name} from Location?" values={{ name: fullName }} />);

const promoteText = (numUsers) => (<FormattedMessage id="UserManagementComponent.promote" defaultMessage="{number} users successfully granted admin privileges" values={{ number: numUsers }} />);
const withdrawText = (numUsers) => (<FormattedMessage id="UserManagementComponent.withdraw" defaultMessage="Admin privileges withdrawn for {number} users" values={{ number: numUsers }} />);
const removeText = (numUsers) => (<FormattedMessage id="UserManagementComponent.remove" defaultMessage="{number} users successfully removed from this location" values={{ number: numUsers }} />);
const approveText = (numUsers) => (<FormattedMessage id="UserManagementComponent.approve" defaultMessage="{number} users approved" values={{ number: numUsers }} />);
const denyText = (numUsers) => (<FormattedMessage id="UserManagementComponent.deny" defaultMessage="{number} users denied" values={{ number: numUsers }} />);
const createdGroup = (channelName) => (<FormattedMessage id="UserManagementComponent.createGroup" defaultMessage="Group {name} successfully created" values={{ name: channelName }} />);
const createdDept = (deptName) => (<FormattedMessage id="UserManagementComponent.createDept" defaultMessage="Department {name} successfully created" values={{ name: deptName }} />);
const createdSkill = (skillName) => (<FormattedMessage id="UserManagementComponent.createSkill" defaultMessage="Skill {name} successfully created" values={{ name: skillName }} />);
const addedToGroup = (numUsers) => (<FormattedMessage id="UserManagementComponent.addedToGroup" defaultMessage="{number, plural, one {{number} user successfully added to group} other {{number} users successfully added to group}}" values={{ number: numUsers }} />);
const removedFromGroup = (numUsers) => (<FormattedMessage id="UserManagementComponent.removedFromGroup" defaultMessage="{number, plural, one {{number} user successfully removed from group} other {{number} users successfully removed from group}}" values={{ number: numUsers }} />);
const addedToDept = (numUsers) => (<FormattedMessage id="UserManagementComponent.addedToDept" defaultMessage="{number, plural, one {{number} user successfully added to department} other {{number} users successfully added to department}}" values={{ number: numUsers }} />);
const removeFromDept = (numUsers) => (<FormattedMessage id="UserManagementComponent.removeFromDept" defaultMessage="{number, plural, one {{number} user successfully removed from department} other {{number} users successfully removed from department}}" values={{ number: numUsers }} />);
const addToSkill = (numUsers) => (<FormattedMessage id="UserManagementComponent.addToSkill" defaultMessage="{number, plural, one {{number} user successfully added to the skill} other {{number} users successfully added to the skill}}" values={{ number: numUsers }} />);
const removeFromSkill = (numUsers) => (<FormattedMessage id="UserManagementComponent.removeFromSkill" defaultMessage="{number, plural, one {{number} user successfully removed from the skill} other {{number} users successfully removed from the skill}}" values={{ number: numUsers }} />);

const grantAminPriv = (<FormattedMessage id="Header.promote" defaultMessage="Grant Admin Privileges" />);
const withdrawAdminPriv = (<FormattedMessage id="Header.withdraw" defaultMessage="Withdraw Admin Privileges" />);
const removeFromLocation = (<FormattedMessage id="Header.remove" defaultMessage="Remove User from Location" />);

const userAccess = (<FormattedMessage id="Header.userAccess" defaultMessage="User Access" />);
const sortBy = (<FormattedMessage id="Header.sortBy" defaultMessage="Sort by" />);
const userRoleText = (<FormattedMessage id="Header.userRole" defaultMessage="User Role" />);
const results = (num) => (<FormattedMessage id="Header.results" defaultMessage="{number} results" values={{number: num}}/>);
const addFilters = (<FormattedMessage id="Header.addFilters" defaultMessage="Add Filters" />);
const approveUsers = (numUsers) => (<FormattedMessage id="Header.approveUsers" defaultMessage="Approve {number}" values={{number: numUsers}}/>);
const denyUsers = (numUsers) => (<FormattedMessage id="Header.denyUsers" defaultMessage="Deny {number}" values={{number: numUsers}}/>);
const add = (<FormattedMessage id="Header.addUsers" defaultMessage="Add" />);
const  deptIs = (<FormattedMessage id="Header.departmentIs" defaultMessage="Department is" />);
const  emailIs = (<FormattedMessage id="Header.emailIs" defaultMessage="Email is" />);
const  employeeIdIs = (<FormattedMessage id="Header.employeeIdIs" defaultMessage="Employee ID is" />);
const groupIs = (<FormattedMessage id="Header.groupIs" defaultMessage="Group is" />);
const jobTitleIs = (<FormattedMessage id="Header.jobTitleIs" defaultMessage="Job Title is" />);
const skillIs = (<FormattedMessage id="Header.skillIs" defaultMessage="Skill is" />);

const role = (<FormattedMessage id="Role.role" defaultMessage="Role" />);
const roles = (<FormattedMessage id="Role.roles" defaultMessage="Roles" />);
const manageRoleSkill = (<FormattedMessage id="Role.manageRoleSkill" defaultMessage="Manage Roles" />);
const roleExplain = (<FormattedMessage id="Role.explain" defaultMessage="Roles are the jobs an employee can work at your business, each shift should have a Role assigned to it, but it is not required." />);
const addNewRole = (<FormattedMessage id="Role.addNewRole" defaultMessage="+ Add New Role" />);
const addNewSkill = (<FormattedMessage id="Role.addNewSkill" defaultMessage="+ Add New Skill" />);
const skillExplain = (<FormattedMessage id="Role.skillExplain" defaultMessage="Skills are custom attributes that are assigned to users. When you post a shift to any audience, you can add additional Skills that are required. " /> );


const createRole = (<FormattedMessage id="Role.createRole" defaultMessage="Create Role" />);
const createRoleExplain = (<FormattedMessage id="Role.createRoleExplain" defaultMessage="Roles are the jobs an employee can work at your business, each shift should have a Role assigned to it, but it is not required." />);
const roleName = (<FormattedMessage id="Role.roleName" defaultMessage="Role Name" />);
const color = (<FormattedMessage id="Role.color" defaultMessage="Color" />);

const roleNameEmptyError = (<FormattedMessage id="Role.roleNameEmptyError" defaultMessage="Role name cannot be empty or contain only spaces" />);
const roleNameConflictError = (<FormattedMessage id="Role.roleNameConflictError" defaultMessage="A role with this name already exists" />);

// DetailFieldRoleComponent strings
const noRole = (<FormattedMessage id="DetailFieldRole.noRole" defaultMessage="No Role" />);
const selectRole = (<FormattedMessage id="DetailFieldRole.selectRole" defaultMessage="Select Role" />);
const createRoleOption = (<FormattedMessage id="DetailFieldRole.createRole" defaultMessage="Create Role" />);
const enterRoleName = (<FormattedMessage id="DetailFieldRole.enterRoleName" defaultMessage="Enter role name" />);

const voluntaryTimeOff = (<FormattedMessage id="VTOTableRow.voluntaryTimeOff" defaultMessage="Voluntary Time Off" />);

// UserRow display texts
const userRowAdmin = (<FormattedMessage id="UserRow.admin" defaultMessage="Admin" />);
const userRowTeamMember = (<FormattedMessage id="UserRow.teamMember" defaultMessage="Team Member" />);
const userRowNone = (<FormattedMessage id="UserRow.none" defaultMessage="None" />);
const userRowNumDepts = (value) => (<FormattedMessage id="UserRow.numDepts" defaultMessage="{value, plural, one {{value} department} other {{value} departments}}" values={{ value }} />);
const userRowNumSkills = (value) => (<FormattedMessage id="UserRow.numSkills" defaultMessage="{value, plural, one {{value} skill} other {{value} skills}}" values={{ value }} />);
const userRowNumGroups = (value) => (<FormattedMessage id="UserRow.numGroups" defaultMessage="{value, plural, one {{value} group} other {{value} groups}}" values={{ value }} />);
const userRowAddPhone = (<FormattedMessage id="UserRow.addPhone" defaultMessage="+ Add Phone" />);
const userRowAddEmail = (<FormattedMessage id="UserRow.addEmail" defaultMessage="+ Add Email" />);
const userRowEditEmployeeId = (<FormattedMessage id="UserRow.editEmployeeId" defaultMessage="Edit Employee ID" />);
const userRowNumRoles = (value) => (<FormattedMessage id="UserRow.numRoles" defaultMessage="{value, plural, one {{value} role} other {{value} roles}}" values={{ value }} />);

const deleteShiftText = () => { return <FormattedMessage id="ShiftDetail.delete" defaultMessage='Delete Shift' />; }
const deleteVTOText = () => { return <FormattedMessage id="ShiftDetail.deleteVTO" defaultMessage='Delete VTO' />; }

const copyShiftText = () =>  { return <FormattedMessage id="ShiftDetail.copyShift" defaultMessage='Copy Shift' />; }
const copyVTOText = () =>  { return <FormattedMessage id="ShiftDetail.copyVTO" defaultMessage='Copy VTO' />; }

const shiftDescription = () => { return <FormattedMessage id="ShiftDetail.shiftDescription" defaultMessage='Shift Description' />; }
const vtoDescription = () => { return <FormattedMessage id="ShiftDetail.vtoDescription" defaultMessage='VTO Description' />; }

const VTO = () => { return <FormattedMessage id="ShiftDetail.vto" defaultMessage='VTO' />; }

const vtoDetails = () => { return <FormattedMessage id="ShiftDetail.vtoDetails" defaultMessage='VTO Details' />; }
const shiftDetails = () => { return <FormattedMessage id="ShiftDetail.shiftDetails" defaultMessage='Shift Details' />; }

export default {
    firstLastNameIntl,
    companyEmailIntl,
    phoneIntl,
    jobTitleIntl,
    enterEmployeeIDIntl,
    selectAccessLevelIntl,
    unregisteredIntl,
    pendingIntl,
    activeIntl,    
    adminIntl,
    teamMemberIntl,
    emptyIntl,
    addTeamMember,
    cancel,
    confirm,
    employeeProfile,
    employeeInformation,
    profilePhoto,
    fullName,
    email,
    phone,
    jobTitle,
    employeeID,
    accessLevel,
    status,
    removeUser,
    inviteUser,
    edit,
    save,
    group,
    groupExplain,
    addNewGroup,
    admin,
    teamMember,
    removePhotoExplain,
    removePhotoTitle,
    removeUserExplain,
    removeUserTitle,
    remove,
    notVerified,

    department,
    departments,
    skills,
    contactInfo,
    rolesAndSkills,

    promoteText,
    withdrawText,
    removeText,
    approveText,
    denyText,
    createdGroup,
    createdDept,
    createdSkill,
    addedToGroup,
    removedFromGroup,
    addedToDept,
    removeFromDept,
    addToSkill,
    removeFromSkill,
    removeSkill,
    removeSkillExplain,
    removeRole,
    removeRoleExplain,

    grantAminPriv,
    withdrawAdminPriv,
    removeFromLocation,

    userAccess,
    sortBy,
    userRoleText,
    results,
    addFilters,
    approveUsers,
    denyUsers,
    add,
    deptIs,
    emailIs,
    employeeIdIs,
    groupIs,
    jobTitleIs,
    skillIs,

    role,
    roles,
    manageRoleSkill,
    roleExplain,
    addNewRole,
    addNewSkill,
    skillExplain,

    createRole,
    createRoleExplain,
    roleName,
    color,

    roleNameEmptyError,
    roleNameConflictError,

    // DetailFieldRoleComponent strings
    noRole,
    selectRole,
    createRoleOption,
    enterRoleName,

    // UserRow display texts
    userRowAdmin,
    userRowTeamMember,
    userRowNone,
    userRowNumDepts,
    userRowNumSkills,
    userRowNumGroups,
    userRowNumRoles,
    userRowAddPhone,
    userRowAddEmail,
    userRowEditEmployeeId,

    // VTOTableRow display texts
    voluntaryTimeOff,

    // ShiftDetail display texts
    deleteShiftText,
    deleteVTOText,
    copyShiftText,
    copyVTOText,

    shiftDescription,
    vtoDescription,
    VTO,
    vtoDetails,
    shiftDetails,
}